import Axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
Axios.defaults.baseURL = API_URL;

export class HttpService {
  _axios = Axios.create();

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, async (error) => {
      const originalRequest = error.config;

      if (
          error.response?.status === 401 &&
          !originalRequest._retry &&
          localStorage.getItem("refresh_token")
      ) {
        originalRequest._retry = true;
        try {
          const response = await this._axios.post("/auth/refresh", {
            refresh_token: localStorage.getItem("refresh_token"),
          });

          const newToken = response.data.access_token;
          localStorage.setItem("token", newToken);

          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;

          return this._axios(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem("token");
          localStorage.removeItem("refresh_token");
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    });
  };

  // ✅ config support (params, headers vs.)
  get = async (url, config = {}) =>
      await this.request(this.getOptionsConfig("get", url, null, config));

  post = async (url, data, config = {}) =>
      await this.request(this.getOptionsConfig("post", url, data, config));

  put = async (url, data, config = {}) =>
      await this.request(this.getOptionsConfig("put", url, data, config));

  patch = async (url, data, config = {}) =>
      await this.request(this.getOptionsConfig("patch", url, data, config));

  delete = async (url, config = {}) =>
      await this.request(this.getOptionsConfig("delete", url, null, config));

  // ✅ config merge: params taşınır
  getOptionsConfig = (method, url, data, config = {}) => {
    const isFormData = data instanceof FormData;

    return {
      method,
      url,
      data,
      headers: {
        "Content-Type": isFormData
            ? "multipart/form-data"
            : "application/vnd.api+json",
        ...(config.headers || {}),
      },
      ...config, // ✅ { params: {...} } burada axios'a gider
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
          .request(options)
          .then((res) => resolve(res.data))
          .catch((ex) => reject(ex.response?.data || ex));
    });
  }
}

export default new HttpService();
